export const environmentData = {
  run: 'production',
  development: {
    clientId: '2bed318e-3dd8-4397-8ad0-513ccfbb6a74',
    authority: 'https://login.microsoftonline.com/30f52344-4663-4c2e-bab3-61bf24ebbed8',
    tenantId: '30f52344-4663-4c2e-bab3-61bf24ebbed8',
    'api-scope': 'openid 2bed318e-3dd8-4397-8ad0-513ccfbb6a74/User.Impersonation',
    appInsightConnectionString:
      'InstrumentationKey=08e33dd4-e12c-420b-b561-6f36cbcd236a;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=b5e5a06c-4295-4e6e-bc8c-0b0fadee9b7e',
    apiBaseURL:
      'https://smartstore-dashboard-api-dev-gfauckhja8hvbzh6.westeurope-01.azurewebsites.net/api',
  },
  staging: {
    clientId: '2bed318e-3dd8-4397-8ad0-513ccfbb6a74',
    authority: 'https://login.microsoftonline.com/30f52344-4663-4c2e-bab3-61bf24ebbed8',
    tenantId: '30f52344-4663-4c2e-bab3-61bf24ebbed8',
    'api-scope': 'openid 2bed318e-3dd8-4397-8ad0-513ccfbb6a74/User.Impersonation',
    appInsightConnectionString:
      'InstrumentationKey=08e33dd4-e12c-420b-b561-6f36cbcd236a;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=b5e5a06c-4295-4e6e-bc8c-0b0fadee9b7e',
    apiBaseURL: 'https://dev-api-execdb-ps.azurewebsites.net/api',
  },
  production: {
    clientId: '78fb5619-19f1-4093-a80e-433ad1224ee9',
    authority: 'https://login.microsoftonline.com/30f52344-4663-4c2e-bab3-61bf24ebbed8',
    tenantId: '30f52344-4663-4c2e-bab3-61bf24ebbed8',
    'api-scope': 'openid 78fb5619-19f1-4093-a80e-433ad1224ee9/User.Impersonation',
    appInsightConnectionString:
      'InstrumentationKey=08e33dd4-e12c-420b-b561-6f36cbcd236a;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=b5e5a06c-4295-4e6e-bc8c-0b0fadee9b7e',
    apiBaseURL:
      'https://smartstore-dashboard-api-prd-eqcwfue6hjg3gfad.westeurope-01.azurewebsites.net/api',
  },
}
